(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initOne(el){
    if(el.dataset.init==='1') return;
    el.dataset.init='1';

    const imgs = el.querySelectorAll('img');
    if(imgs.length < 2) return;

    // אל תיתן לגרור את התמונות עצמן
    imgs.forEach(img => { img.draggable = false; img.addEventListener('dragstart', e => e.preventDefault()); });

    // יחס ממדים לפי AFTER כדי למנוע קפיצה
    const ref = imgs[1] || imgs[0];
    const setAR = () => {
      if(ref.naturalWidth && ref.naturalHeight){
        el.style.aspectRatio = ref.naturalWidth + ' / ' + ref.naturalHeight;
      }
    };
    ref.complete ? setAR() : ref.addEventListener('load', setAR, {once:true});

    // מחיצה וידית
    el.appendChild(Object.assign(document.createElement('div'), {className:'tt-divider'}));
    el.appendChild(Object.assign(document.createElement('div'), {className:'tt-handle', textContent:'⇆'}));

    // גרירה ישירה - בלי easing בכלל
    let dragging = false;

    const setFromClientX = (clientX) => {
      const r = el.getBoundingClientRect();
      const x = Math.min(Math.max(clientX - r.left, 0), r.width);
      const p = (x / r.width) * 100;
      el.style.setProperty('--pos', p.toFixed(2)); // מעדכן מיד ללא אנימציה
    };

    const onMove = (ev) => {
      if(!dragging) return;
      setFromClientX(ev.clientX);
      ev.preventDefault();
    };
    const onUp = () => {
      dragging = false;
      window.removeEventListener('pointermove', onMove);
      window.removeEventListener('pointerup', onUp);
      window.removeEventListener('pointercancel', onUp);
    };

    el.addEventListener('pointerdown', (e) => {
      dragging = true;
      setFromClientX(e.clientX);
      window.addEventListener('pointermove', onMove, {passive:false});
      window.addEventListener('pointerup', onUp);
      window.addEventListener('pointercancel', onUp);
      e.preventDefault();
    });

    // גם קליק ממקם
    el.addEventListener('click', (e) => setFromClientX(e.clientX), {passive:true});

    // מצב התחלתי
    el.style.setProperty('--pos', '50');
  }

  function initScope(scope){
    scope.querySelectorAll('.twentytwenty-container').forEach(initOne);
  }

  // טעינה ראשונית
  const root = document.getElementById('shopify-section-{{ section.id }}') || document;
  initScope(root);

  // תמיכה בעורך
  document.addEventListener('shopify:section:load', (e) => initScope(e.target));
})();

  } catch(e) { console.error(e); }
})();
})();
